import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58f2045f")

_pushScopeId("data-v-58f2045f")
const _hoisted_1 = { class: "el-button padding-5 tag-filter" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_tag_input, {
        onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search', _ctx.filterTags))),
        alwaysShowInput: true,
        modelValue: _ctx.filterTags,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterTags = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_button, {
      class: "tag-filter-button",
      type: "success",
      icon: "el-icon-search",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('search', _ctx.filterTags)))
    })
  ], 64))
})